import React from 'react';
import { motion } from 'framer-motion';

export default function ManifestoSection() {
  return (
    <section className="section-padding relative overflow-hidden" data-testid="manifesto-section">
      <div className="section-divider mb-24" />
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-xs tracking-[0.3em] text-white/30 uppercase mb-6">Manifesto</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl leading-[1.05] mb-8">
            WE DON'T DESIGN.
            <br />
            <span className="text-white/25">WE BUILD VISIONS.</span>
          </h2>
          <p className="text-white/40 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Archangelworks exists at the intersection of artificial intelligence and elite aesthetics.
            Every asset we create is a collision between machine precision and human vision — 
            producing work that feels otherworldly yet unmistakably intentional.
          </p>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-24 pt-12 border-t border-white/5"
        >
          {[
            { value: '50+', label: 'Projects Delivered' },
            { value: '33', label: 'Global Clients' },
            { value: '97%', label: 'Client Retention' },
            { value: '$1M+', label: 'Revenue Generated' },
          ].map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 * i, duration: 0.6 }}
            >
              <p className="font-heading text-3xl md:text-4xl mb-2" data-testid={`stat-value-${i}`}>{stat.value}</p>
              <p className="font-mono text-xs tracking-[0.15em] text-white/30 uppercase">{stat.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
